
import Vue from 'vue'

export default Vue.extend({
	props: {
		variant: {
			type: String as () => 'default' | 'op-common-ui',
			default: 'default'
		},
		required: {
			type: Boolean,
			default: true
		},
		id: {
			type: String,
			default: ''
		},
		label: {
			type: String,
			default: ''
		},
		type: {
			type: String,
			default: 'text'
		},
		inputType: {
			type: String,
			default: 'text'
		},
		placeholder: {
			type: String,
			default: ''
		},
		value: {
			type: String,
			default: ''
		},
		error: {
			type: Boolean,
			default: false
		},
		errorText: {
			type: String,
			default: ''
		},
		disabled: {
			type: Boolean,
			default: false
		},
		hint: {
			type: String,
			default: ''
		},
		numericOnly: {
			type: Boolean,
			default: false
		},
		minLength: {
			type: Number,
			default: 0
		},
		maxLength: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			passwordVisible: false,
			passwordVisibiltyIcons: ['opVisibilityOff', 'opVisibility'],
			passwordToggleType: ['password', 'text']
		}
	},
	computed: {
		normalizedVariant(): 'default' | 'op-common-ui' {
			return this.variant === 'op-common-ui' ? 'op-common-ui' : 'default'
		},
		resolvedId(): string | undefined {
			return this.id || undefined
		},
		variantClass(): string {
			return this.normalizedVariant === 'op-common-ui' ? 'op-text-field--op-common-ui' : ''
		},
		isOpCommonUiVariant(): boolean {
			return this.normalizedVariant === 'op-common-ui'
		},
		isPasswordType(): boolean {
			return this.inputType === 'password'
		},
		textFieldType(): string {
			const idx = +this.passwordVisible
			return this.isPasswordType ? this.passwordToggleType[idx] : this.type
		},
		passwordVisibleIcon(): string {
			const idx = +this.passwordVisible
			return '$vuetify.icons.' + this.passwordVisibiltyIcons[idx]
		},
		isValidValue(): boolean {
			return !this.error && !!this.value
		},
		computedInputMode(): 'numeric' | undefined {
			return this.numericOnly ? 'numeric' : undefined
		},
		computedPattern(): string | undefined {
			return this.numericOnly ? '\\d*' : undefined
		}
	},
	methods: {
		sanitizeInputValue(rawValue: string): string {
			let next = rawValue
			if (this.numericOnly) {
				next = next.replace(/[^\d]/g, '')
			}
			if (this.maxLength && next.length > this.maxLength) {
				next = next.slice(0, this.maxLength)
			}
			return next
		},
		onChange(val: string): void {
			const next = this.sanitizeInputValue(val || '')
			this.$emit('change', next)
			this.$emit('input', next)
		},
		onKeyup(kbd: KeyboardEvent): void {
			const input = kbd.target as HTMLInputElement
			this.$emit('keyup', input?.value)
		},
		onKeypress(evt: KeyboardEvent): void {
			if (!this.numericOnly) return
			// Allow control/navigation keys and block non-digit printable chars.
			if (evt.ctrlKey || evt.metaKey || evt.altKey) return
			const key = evt.key
			if (key.length === 1 && !/\d/.test(key)) {
				evt.preventDefault()
			}
		},
		onPaste(evt: ClipboardEvent): void {
			if (!this.numericOnly) return
			const pasted = evt.clipboardData?.getData('text') || ''
			if (/[^\d]/.test(pasted)) {
				evt.preventDefault()
			}
		},
		onTogglePasswordVisibility(): void {
			this.passwordVisible = !this.passwordVisible
		}
	}
})
